import { render, staticRenderFns } from "./ColorPickerItem.vue?vue&type=template&id=534f086e"
import script from "./ColorPickerItem.vue?vue&type=script&lang=js"
export * from "./ColorPickerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports